





















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import type { SwiperOptions } from 'swiper';

export default defineComponent({
  components: {
    AppImage,
  },
  props: {
    items: {
      type: Array as PropType<string[]>,
      required: true,
    },
    altName: {
      type: String,
      default: '',
    },
    noImageType: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const swiperOptions: SwiperOptions = {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 2,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index: any, className: any) {
          return (
            '<div class="' +
            className +
            '">' +
            '<div class="progress-bar">' +
            '<div class="progress"></div>' +
            '</div></div>'
          );
        },
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    return { props, swiperOptions };
  },
});
